export enum SagaType {
  Account = 'account_signup',
  AccountInvite = 'account_invite',
  UserInvite = 'user_invite',
}
